/**
 * @fileoverview POST handler for the "/engagement/campaigns/create_default" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCreateDefaultCacheKeys } from "./constants";
import type { EngagementCampaignsCreateDefaultResult } from "./types";

export const postEngagementCampaignsCreateDefault = reactQueryMutationAdapter(
  engagementCampaignsCreateDefaultCacheKeys,
  (props: {
    campaign_type: string;
    segment_ids?: string[];
    name?: string;
  }): Promise<EngagementCampaignsCreateDefaultResult> => {
    return fetch("/engagement/campaigns/create_default", "POST", props);
  }
);
